import { DateFormatEnum as o } from "../enums/date-time-format/index.mjs";
import { LanguageCodeEnum as a } from "../libs/types/dist/index12.mjs";
const r = (e, t) => new Date(
  new Intl.DateTimeFormat(a.ENGLISH, {
    timeZone: t,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }).format(e)
), D = (e, t) => e ? e instanceof Date ? r(e, t) : e.match(/([-+]\d+:?\d+)$/) ? r(new Date(e), t) : new Date(e) : r(/* @__PURE__ */ new Date(), t), f = (e) => {
  const t = function(n) {
    return (n < 10 ? "0" : "") + n;
  };
  return e.getFullYear() + "-" + t(e.getMonth() + 1) + "-" + t(e.getDate()) + "T" + t(e.getHours()) + ":" + t(e.getMinutes()) + ":" + t(e.getSeconds());
}, u = (e) => {
  switch (e) {
    case o.dateFirst:
      return "en-GB";
    case o.monthFirst:
      return "en-US";
    default:
      return;
  }
}, h = (e, t) => (typeof e == "string" ? new Date(e) : e).toLocaleString(u(t == null ? void 0 : t.dateFormat), {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: t == null ? void 0 : t.timeZone
}), p = (e, t) => {
  if (!t && !e) return "";
  const i = new Intl.DateTimeFormat(e, {
    timeZone: t,
    timeZoneName: "shortOffset"
  }).formatToParts(/* @__PURE__ */ new Date()).find((s) => s.type === "timeZoneName");
  if (i)
    return i.value.replace("GMT", "UTC");
};
export {
  h as formatDate,
  p as getFormattedUtcOffset,
  r as getTimezoneDate,
  D as setDateWithTimezone,
  f as toISOStringWithoutTimezone
};
